var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMergeRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83325 9.14837V8.25004C1.83325 3.66671 3.66659 1.83337 8.24992 1.83337H13.7499C18.3333 1.83337 20.1666 3.66671 20.1666 8.25004V13.75C20.1666 18.3334 18.3333 20.1667 13.7499 20.1667H12.8333",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9627 7.78573L17.4639 7.77925L14.8647 5.18004",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4634 7.77881L14.8642 10.378",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 14.8041V17.2791C10.0833 19.3416 9.25825 20.1666 7.19575 20.1666H4.72075C2.65825 20.1666 1.83325 19.3416 1.83325 17.2791V14.8041C1.83325 12.7416 2.65825 11.9166 4.72075 11.9166H7.19575C9.25825 11.9166 10.0833 12.7416 10.0833 14.8041Z",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeRightIcon);
export default __webpack_public_path__ + "static/media/merge-right-icon.f0ee651c1e05f35c938b70ad314d18af.svg";
export { ForwardRef as ReactComponent };